<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useSharedUi } from '@/composables/useSharedUi'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import CustomButton from '@/components/customButton/CustomButton.vue'

const isActive = ref(false)
const router = useRouter()
const { t } = useI18n()
const { hideMessageMenu } = useSharedUi()
const { createUmsokn } = useUmsokn()

const props = defineProps<{
  setLoading?: (value: boolean) => void
}>()

async function openApplication() {
  isActive.value = true
  try {
    props.setLoading?.(true)
    const newApp = await createUmsokn(11)
    if (newApp) {
      hideMessageMenu()
      const step = newApp.currentStep && newApp.currentStep > 0 ? newApp.currentStep + 1 : 1
      props.setLoading?.(false)
      router.push({ query: { step } })
    } else {
      console.error('Application was not created.')
    }
  } catch (err) {
    console.error('Failed to create application:', err)
  }
}
</script>

<template>
  <v-container>
    <v-row justify="center">
      <v-col>
        <h1 :class="[isActive ? 'active' : '', 'heading']">
          {{ t('umsokn_lan_nafnabreyting_step0_header') }}
        </h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col md="6">
        <p class="intro-text">
          {{ t('umsokn_lan_nafnabreyting_step0_begin_text') }}
        </p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col md="7">
        <p class="forms__header text-center">
          {{ t('umsokn_lan_nafnabreyting_step0_disclaimer_header') }}
        </p>
        <p class="disclaimer-text">
          {{ t('umsokn_lan_nafnabreyting_step0_disclaimer_text') }}
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex justify-center">
        <CustomButton @click="openApplication">
          {{ t('sereignar_umsokn_begin_button') }}
        </CustomButton>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">
h1 {
  color: #194458;
  font-size: 55px;
  font-weight: 900;
  line-height: 75px;
  text-align: center;
}

.intro-text {
  color: #194458;
  font-size: 21px;
  line-height: 34px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 40px;
}

.disclaimer-text {
  color: #194458;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  margin-bottom: 40px;
}

.heading {
  position: relative;
  font-size: 55px;
}

.active {
  transition: all 0.8s linear;
  top: -900px;
  height: 20px;
  color: #194458;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
}
</style>
